import { useEffect, useState } from 'react'
import { MatchingSkinViewModel } from '../../types'

const PROGRESS_STEP_INTERVAL = 650
const COMPLETION_STATE_DURATION = 400
const MATCHING_STEPS = ['资料已加密保存', '正在为你提交资料', '正在为您匹配资方']

export interface MatchingSkinController {

  /** 仅供 View 渲染的动画进度，不携带旧容器的业务请求状态。 */
  model: MatchingSkinViewModel
}

/**
 * useMatchingSkinController — 匹配皮肤的本地进度动画控制器
 * @param {number} completionDuration 旧业务等待总时长；传入后末项勾选会贴近跳转时刻出现
 * @returns {MatchingSkinController} 当前动画步骤及固定展示文案
 */
const useMatchingSkinController = (completionDuration?: number): MatchingSkinController => {
  const [currentStep, setCurrentStep] = useState(0)
  const progressStepInterval = completionDuration === undefined
    ? PROGRESS_STEP_INTERVAL
    : Math.max(
      (completionDuration - COMPLETION_STATE_DURATION) / MATCHING_STEPS.length,
      1,
    )

  useEffect(() => {
    const timer = window.setInterval(() => {
      // 允许推进至末项后一位，View 才能将最后一个节点标记为已完成。
      setCurrentStep(step => Math.min(step + 1, MATCHING_STEPS.length))
    }, progressStepInterval)

    return () => window.clearInterval(timer)
  }, [progressStepInterval])

  return {
    model: {
      currentStep,
      progressSteps: MATCHING_STEPS,
    },
  }
}

export default useMatchingSkinController
